import BaseMetricHandler from "./BaseMetricHandler";

export default class NewStageTimeHandler extends BaseMetricHandler {
  constructor(groupBy, filterBy) {
    super(groupBy, filterBy);
    this.graphType = "";
    this.showTotals = false;
    this.dataType = "days";
  }

  getGraphOptions(backendData) {
    if (this.groupBy) {
      return this.getBarGraphOptions(backendData);
    } else {
      return backendData.data[0];
    }
  }

  getBarGraphOptions(backendData) {
    let series = backendData.data
      .map((series, index) => {
        return {
          name: backendData.labels[index],
          type: "bar",
          data: series,
          color: "#FEC249",
        };
      })
      .slice(0, BaseMetricHandler.MaxLabels());

    let options = {
      notMerge: true,
      tooltip: {
        trigger: "axis",
        formatter: "{b}<br/><b>{c} days</b>",
      },
      // legend: {
      //   data: backendData.xAxis.slice(0, BaseMetricHandler.MaxLabels()),
      //   top: "bottom",
      // },
      grid: {
        left: "0%",
        right: "0%",
        bottom: "10%",
        containLabel: true,
      },
      toolbox: {
        // feature: {
        //   saveAsImage: {},
        // },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: backendData.xAxis.slice(0, BaseMetricHandler.MaxLabels()),
        axisLabel: {
          interval: 0,
          rotate: 30,
        },
      },
      label: {
        show: true,
        position: "top",
      },
      yAxis: {
        type: "value",
      },
      series: series,
    };
    return options;
  }
}
